import { Component, OnInit, ChangeDetectionStrategy, Input, OnDestroy, Output, EventEmitter } from '@angular/core';
import { get } from 'lodash';

import { DynamicFormItem } from '@ispm/dynamic-form/classes/dynamic-form-item.class';
import { FormHandlerService } from '@ispm/dynamic-form/services/form-handler.service';
import { FormReflect } from '@ispm/dynamic-form/classes/form-reflect.class';
import { IDynamicFormChangeEvent } from '@ispm/dynamic-form/interfaces/update-event.interface';
import { IImmunotherapyFinding } from '../interfaces/immunotherapy-finding.interface';
import { IdynamicFormItem } from '@ispm/dynamic-form/interfaces/IdynamicFormItem';

@Component({
  selector: 'gen-finding-input',
  templateUrl: 'finding-input.component.html',
  styleUrls: ['finding-input.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class FindingInputComponent implements OnInit, OnDestroy {
  @Input() valueObject: IImmunotherapyFinding;
  @Input() editable: boolean;
  @Input() key: string;
  @Input() changed?: { value: boolean, level: boolean };
  @Input() levels?: Array<string>;
  @Input() min?: number;
  @Input() max?: number;
  @Input() regex?: string;
  @Input() defaultValue?: string;
  @Input() defaultLevel?: string;
  @Input() triggers: { value: string, min: number, max: number, checkOnInit: boolean }[] = [];
  @Input() levelAttributes: any;
  @Input() valueAttributes: any;
  @Input()
  set type(type: string) {
    switch (type && type.toLowerCase()) {
      case 'string':
      case 'text':
        this.formItemType = 'TEXT';
        break;
      default:
        this.formItemType = 'NUMBER';
        break;
    }
  }

  get type() {
    return this.formItemType;
  }

  @Output() validationUpdate: EventEmitter<boolean> = new EventEmitter();

  public formConfig: { id: string, inputs: IdynamicFormItem[] };
  public updateObject: { name: string, value: string };

  private formItemType: string;
  private formId: string;
  private defaultLevelAttributes: { [key: string]: string} = { '[appendTo]': 'body'};

  constructor(
    private formHandler: FormHandlerService
  ) {
  }

  ngOnInit() {
    this.formId = 'temp-immunotherapy-' + this.key;
    this.formConfig = { id: this.formId, inputs: []};
    const inputs = [];

    if (this.levels) {
      inputs.push(DynamicFormItem.builder(this.key, 'level', 'DROPDOWN')
        .setDefault(this.defaultLevel)
        .setAttributes(Object.assign({ }, this.defaultLevelAttributes, this.levelAttributes))
        .setOptions(this.levels)
      );
    }

    const reflects = this.buildReflects() || [];

    if (get(this.valueAttributes, 'addValueInput', true)) {
      inputs.push(
        DynamicFormItem.builder(this.key, 'value', this.type)
          .setDefault(this.defaultValue)
          .setAttributes(Object.assign({
            min: this.min,
            max: this.max
          }, this.valueAttributes))
          .addReflects(...reflects)
          .setRegex(this.regex)
      );
    }

    this.formConfig.inputs = inputs;
  }

  ngOnDestroy(): void {
    this.formHandler.removeForm(this.formId);
  }

  protected buildReflects(): Array<FormReflect> {
    return Array.isArray(this.triggers) && this.triggers.map(
      trigger => {
        return FormReflect
          .builder('level')
          .setValue(trigger.value)
          .setNumbericCheck(trigger.min, trigger.max)
          .setCheckOnInit(trigger.checkOnInit)
        ;
      });
  }

  public updateValues(update: Partial<IDynamicFormChangeEvent>) {
    Object.assign(this.valueObject, update.form);
  }

  public updateValidation(valid: boolean) {
    this.validationUpdate.emit(valid);
  }
}
